const ROOT_SELECTOR = '[data-mobile-atc-bar]';
const TOGGLE_SELECTOR = '[data-mobile-atc-color-toggle]';
const DROPDOWN_SELECTOR = '[data-mobile-atc-color-dropdown]';
const OPTION_SELECTOR = '[data-mobile-atc-option-id]';
const OPEN_CLASS = 'mobile-atc-dropdown-open';

const isEnabled = (root) => {
  const bar = root?.querySelector('.mobile-atc-bar');

  return (
    document.documentElement.classList.contains('shopify-design-mode') ||
    (bar && getComputedStyle(bar).display !== 'none')
  );
};

const closeDropdown = (root, restoreFocus = false) => {
  const toggle = root?.querySelector(TOGGLE_SELECTOR);
  const dropdown = root?.querySelector(DROPDOWN_SELECTOR);

  if (!toggle || !dropdown) return;

  dropdown.hidden = true;
  toggle.setAttribute('aria-expanded', 'false');
  document.documentElement.classList.remove(OPEN_CLASS);

  if (restoreFocus) toggle.focus();
};

const closeAllDropdowns = (restoreFocus = false) => {
  for (const root of document.querySelectorAll(ROOT_SELECTOR)) {
    closeDropdown(root, restoreFocus);
  }
};

const openDropdown = (root, focusOption = false, focusLast = false) => {
  const toggle = root?.querySelector(TOGGLE_SELECTOR);
  const dropdown = root?.querySelector(DROPDOWN_SELECTOR);

  if (!toggle || !dropdown || !isEnabled(root)) return;

  closeAllDropdowns();
  dropdown.hidden = false;
  toggle.setAttribute('aria-expanded', 'true');
  document.documentElement.classList.add(OPEN_CLASS);

  if (!focusOption) return;

  const options = [...dropdown.querySelectorAll(`${OPTION_SELECTOR}:not(:disabled)`)]
  const selected = dropdown.querySelector(`${OPTION_SELECTOR}[aria-selected="true"]:not(:disabled)`);
  const option = focusLast ? options[options.length - 1] : selected || options[0];
  option?.focus();
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest(TOGGLE_SELECTOR);

  if (toggle) {
    const root = toggle.closest(ROOT_SELECTOR);
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    isOpen ? closeDropdown(root) : openDropdown(root);
    return;
  }

  const option = event.target.closest(OPTION_SELECTOR);

  if (option && !option.disabled) {
    const root = option.closest(ROOT_SELECTOR);
    if (!isEnabled(root)) return;

    const productId = root?.dataset.mobileAtcBar;
    const productOptions = document.querySelector(`[data-product-options="${productId}"]`);
    const nativeOption = productOptions?.querySelector(
      `[data-product-option="${option.dataset.mobileAtcOptionId}"]`
    );

    closeDropdown(root);
    nativeOption?.click();
    return;
  }

  if (!event.target.closest(DROPDOWN_SELECTOR)) closeAllDropdowns();
});

document.addEventListener('keydown', (event) => {
  const toggle = event.target.closest(TOGGLE_SELECTOR);

  if (toggle && event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
    event.preventDefault();
    closeDropdown(toggle.closest(ROOT_SELECTOR), true);
    return;
  }

  if (toggle && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
    event.preventDefault();
    openDropdown(toggle.closest(ROOT_SELECTOR), true, event.key === 'ArrowUp');
    return;
  }

  const option = event.target.closest(OPTION_SELECTOR);
  if (!option) return;

  const root = option.closest(ROOT_SELECTOR);

  if (event.key === 'Escape') {
    event.preventDefault();
    closeDropdown(root, true);
    return;
  }

  const options = [...root.querySelectorAll(`${OPTION_SELECTOR}:not(:disabled)`)]
  const index = options.indexOf(option);
  let nextIndex;

  if (event.key === 'ArrowDown') nextIndex = (index + 1) % options.length;
  if (event.key === 'ArrowUp') nextIndex = (index - 1 + options.length) % options.length;
  if (event.key === 'Home') nextIndex = 0;
  if (event.key === 'End') nextIndex = options.length - 1;

  if (nextIndex !== undefined) {
    event.preventDefault();
    options[nextIndex]?.focus();
  }
});

document.addEventListener('product:options-updated', () => {
  document.documentElement.classList.remove(OPEN_CLASS);
});
